// extracted by mini-css-extract-plugin
export var form = "ContactForm-module--form--1yS5i";
export var formItem = "ContactForm-module--form-item--3Y8ln";
export var formLabel = "ContactForm-module--form-label--2vHWe";
export var inputText = "ContactForm-module--input-text--3kvEU";
export var inputArea = "ContactForm-module--input-area--oZ0RB";
export var notification = "ContactForm-module--notification--1DaPZ";